import script from "./FragmentOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./FragmentOptions.vue?vue&type=script&setup=true&lang=ts"

import "./FragmentOptions.vue?vue&type=style&index=0&id=36d6b22b&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d6b22b"]])

export default __exports__